import ReactController from '~/controllers/react_controller'
import AWSLoadBalancerMetricsCharts from '~/dashboard/aws_load_balancer_metrics_charts'

export default class AWSLoadBalancerMetricsChartsController extends ReactController {
  static values = {
    organizationId: String,
    resourceId: String,
  }

  createComponent() {
    return <AWSLoadBalancerMetricsCharts organizationId={this.organizationIdValue} resourceId={this.resourceIdValue} />
  }
}
